import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { SuspenseOutlet } from "@/components/feedback/SuspenseOutlet";
import { TopBar } from "@/components/shared/navigation/TopBar";
import { GlobalToastContainer } from "@/components/ui/GlobalToastContainer";
import { ToastContainer } from "@/components/ui/Toast";
import { useLoginRedirectHandler } from "@/hooks/useLoginRedirectHandler";
import { useToast } from "@/hooks/useToast";
import { useEditorPanelStore } from "@/stores/useEditorPanelStore";

import { EditorSidebarBody, EditorSidebarHeader } from "./editor-sidebar";

function SkipLink() {
	const { t } = useTranslation();
	return (
		<a
			href="#main-content"
			className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-popover focus:px-4 focus:py-2 focus:bg-primary-hover focus:text-text-inverse focus:rounded-md focus:text-sm focus:font-medium"
		>
			{t("hub.accessibility.skip_to_content", "Saltar al contenido")}
		</a>
	);
}

export default function EditorLayout() {
	useLoginRedirectHandler();
	const { toasts, dismissToast } = useToast();
	const closeSidebar = useEditorPanelStore((state) => state.closeSidebar);

	useEffect(() => {
		closeSidebar();
	}, [closeSidebar]);

	return (
		<div className="flex h-screen flex-col bg-app overflow-hidden">
			<SkipLink />
			<div className="flex items-stretch flex-shrink-0">
				<EditorSidebarHeader />
				<div className="flex-1 min-w-0">
					<TopBar />
				</div>
			</div>
			<div className="flex flex-1 min-h-0">
				<EditorSidebarBody />
				<main
					id="main-content"
					className="flex-1 overflow-hidden"
					tabIndex={-1}
				>
					<SuspenseOutlet />
				</main>
			</div>
			<ToastContainer
				toasts={toasts}
				onDismiss={dismissToast}
				showCloseButton
			/>
			<GlobalToastContainer />
		</div>
	);
}
